import React from 'react';
import ReactMarkdown, { Options } from 'react-markdown';
import styled from 'styled-components';

import { FormPublicDesignFragment } from '../../graphql/fragment/form.public.fragment';

interface Props extends Options {
  type: 'question' | 'answer';
  design: FormPublicDesignFragment;
  children?: string | null;
}

const getColor = ({
  design,
  type,
}: {
  design: FormPublicDesignFragment;
  type: 'question' | 'answer';
}) => (type === 'question' ? design.colors.question : design.colors.answer);

const Markdown = styled(ReactMarkdown)<{
  design: FormPublicDesignFragment;
  type: 'question' | 'answer';
}>`
  color: ${({ design, type }) => getColor({ design, type })};

  h1,
  h2,
  h3,
  h4,
  h5,
  h6,
  p,
  span,
  div {
    color: ${({ design, type }) => getColor({ design, type })};
  }

  blockquote {
    color: ${({ design, type }) => getColor({ design, type })};
    padding-left: 20px;
    border-left: 10px rgba(0, 0, 0, 0.05) solid;
  }

  table {
    border-collapse: collapse;
    border-spacing: 0;

    tr {
      border-top: 1px solid ${({ design, type }) => getColor({ design, type })};

      th,
      td {
        padding: 6px 13px;
        border: 1px solid ${({ design, type }) => getColor({ design, type })};
      }
    }

    tr:nth-child(2n) {
      background: rgba(0, 0, 0, 0.05);
    }
  }
`;

export const StyledMarkdown: React.FC<Props> = ({ children, ...props }) => {
  return <Markdown {...props}>{children}</Markdown>;
};
